class Input {
  init() {
    this.recalculateQuantityInputsWidth();
    this._initEventListeners();
  }

  recalculateQuantityInputsWidth() {
    const quantityInputs = document.querySelectorAll('.qty');

    if (quantityInputs.length) {
      quantityInputs.forEach((input) => {
        if (input.classList.contains('qty')) {
          this.updateInputWidth(input);
        }
      });
    }
  }

  _initEventListeners() {
    document.addEventListener('input', (e) => {
      const input = e.target;
      if (input.classList.contains('qty')) {
        this.updateInputWidth(input);
      }
    });

    jQuery(document.body).on('wc_fragments_refreshed', () => this.recalculateQuantityInputsWidth());
  }

  updateInputWidth(input) {
    const value = parseInt(input.value, 10);

    if (value > 9) {
      input.style.width = '31px';
    }

    if (value > 99) {
      input.style.width = '43px';
    }

    if (value > 999) {
      input.style.width = '58px';
    }

    if (value < 9) {
      input.style.width = '20px';
    }
  }
}

export default Input;
